"use client";

import { ArrowRight, ShieldCheck, FileText, Globe } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Complianceresources() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "No 01",
    title: "REGULATORY EXCELLENCE",
    Icon: ShieldCheck,
    body: "We navigate complex international regulatory landscapes with precision. Our team ensures every medical device we distribute meets the highest safety and quality standards required by global health authorities.",
    italic: "Safety is our foundational promise.",
    offset: "md:translate-y-0"
  }, {
    number: "No 02",
    title: "CLINICAL DOCUMENTATION",
    Icon: FileText,
    body: "Transparency is key to trust. We provide comprehensive clinical data, validation reports, and technical documentation to support healthcare professionals in making informed, evidence-based decisions.",
    italic: "Evidence-backed medical innovation.",
    offset: "md:-translate-y-12"
  }, {
    number: "No 03",
    title: "GLOBAL COMPLIANCE",
    Icon: Globe,
    body: "Our distribution network adheres to strict international trade laws and local healthcare regulations, ensuring seamless, ethical, and reliable supply chain operations across all borders.",
    italic: "Connecting markets with integrity.",
    offset: "md:translate-y-12"
  }];
  return <section data-section-id="3504" id="complianceresources" className="bg-background text-foreground py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={header.ref} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default font-bold tracking-[0.3em] uppercase mb-6 text-blue-600" style={{
          fontSize: "11px"
        }}>
            Our Commitment
          </p>
          <h2 className="font-default font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight text-foreground leading-[0.95] mb-6">
            COMPLIANCE
            <span className="text-blue-600">.</span>
          </h2>
          <p className="font-default italic text-lg text-muted-foreground max-w-xl mx-auto">
            Ensuring quality and safety in every medical solution we deliver.
          </p>
        </div>

        {}
        <div ref={cardsReveal.ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div key={i} data-index={i} className={`group transition-all duration-1000 ease-out ${pillar.offset} ${cardsReveal.isVisible ? "opacity-100" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="relative h-full min-h-[520px] p-10 flex flex-col rounded-lg border backdrop-blur-sm transition-all duration-500 ease-out group-hover:-translate-y-2 shadow-md" style={{
              backgroundColor: "white",
              borderColor: "hsl(178 15% 89%)"
            }}>
                  {}
                  <div className="absolute inset-0 rounded-lg border opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
                borderColor: "hsl(178 65% 72%)"
              }} />

                  {}
                  <div className="flex items-center justify-between mb-10">
                    <span className="font-default font-bold tracking-widest uppercase text-blue-600" style={{
                  fontSize: "13px"
                }}>
                      {pillar.number}
                    </span>
                  </div>

                  {}
                  <div className="mb-10">
                    <Icon className="w-16 h-16 transition-transform duration-500 group-hover:scale-110 text-blue-600" strokeWidth={1.5} />
                  </div>

                  {}
                  <h3 className="font-default font-extrabold text-3xl md:text-4xl text-foreground mb-5 tracking-tight leading-tight">
                    {pillar.title}
                  </h3>

                  {}
                  <div className="h-[2px] w-6 mb-6 bg-blue-600" />

                  {}
                  <p className="font-default font-light text-[17px] leading-relaxed text-foreground/90 mb-2">
                    {pillar.body}
                  </p>
                  <p className="font-default italic text-[17px] leading-relaxed text-foreground/70 mb-10">
                    {pillar.italic}
                  </p>

                  {}
                  <div className="mt-auto pt-6">
                    <Button asChild variant="ghost" className="h-auto p-0 font-default font-bold tracking-widest uppercase text-xs hover:bg-transparent group/btn text-blue-600">
                      <Link to="/CompliancePage">
                        Learn More
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}